'use client';
import { useEffect, useState } from 'react';

/**
 * Null-rendering client component that owns the ad/script loading side-effects
 * previously in the root layout. Extracted so that app/layout.js can be a
 * server component (required for dynamic `<html lang>` via getLocale()).
 */
export default function ClientScripts() {
  const [scriptsLoaded, setScriptsLoaded] = useState({
    adThrive: false,
    googleAdSense: false,
    btLoader: false,
    adBlockRecovery: false,
  });

  const loadScript = (src, scriptKey, type = 'text/javascript', innerHtml = '') => {
    if (!scriptsLoaded[scriptKey]) {
      setScriptsLoaded((prevState) => ({ ...prevState, [scriptKey]: true }));

      if (document.querySelector(`script[src="${src}"]`)) {
        console.log(`${scriptKey} script already loaded.`);
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.type = type;
      script.async = true;
      script.defer = true;
      if (innerHtml) {
        script.innerHTML = innerHtml;
      }
      script.onload = () => {
        console.log(`${scriptKey} script loaded useEffect`);
      };
      script.onerror = (e) => {
        console.error(`Failed to load ${scriptKey} script:`, e);
        setScriptsLoaded((prevState) => ({ ...prevState, [scriptKey]: false }));
      };
      document.body.appendChild(script);
    }
  };

  useEffect(() => {
    console.log('Version 2');
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      // if (scrollPosition > 100) {
      //   loadThirdPartLib();
      // }
    };

    // window.addEventListener('scroll', handleScroll);
    // window.addEventListener('click', loadThirdPartLib);

    return () => {
      // Cleanup event listeners if the component unmounts
      // window.removeEventListener('scroll', handleScroll);
      // window.removeEventListener('click', loadThirdPartLib);
      // TODO // ads code commented
    };
  }, [scriptsLoaded]);

  return null;
}
